import { readonly, ref } from 'vue'

export interface Toast {
  id: number
  message: string
}

// Singleton transient-toast store (no toast library in the app). Used by the
// dialing session for the "Skipped · {name}" pill. A monotonic counter keys
// toasts (deterministic for tests; no Date/random).
const _toasts = ref<Toast[]>([])
let _seq = 0

export function useToast() {
  function show(message: string, durationMs = 2500): number {
    const id = ++_seq
    _toasts.value = [..._toasts.value, { id, message }]
    setTimeout(() => {
      _toasts.value = _toasts.value.filter((t) => t.id !== id)
    }, durationMs)
    return id
  }

  function dismiss(id: number): void {
    _toasts.value = _toasts.value.filter((t) => t.id !== id)
  }

  return { toasts: readonly(_toasts), show, dismiss }
}
